module.exports = __webpack_public_path__ + "media/St 4-Question 15-question.40553321.wav";